import Ingredient from "./Ingredient";
import common from "../../common";

export default class EggBowl extends Ingredient{
    constructor(textures, position, particleData, particleTextures) {
        super(textures, position, particleData, [P3.assets.texture('ing_egg')]);
        this._eggContainer = new PIXI.Container();
        this.addChild(this._eggContainer);

        this._eggContainer._singleEgg = new PIXI.Sprite(P3.assets.texture('ing_eggs_shelf'));
        this._eggContainer._singleEgg.anchor.set(0.5, 0.5);
        this._eggContainer._singleEgg.scale.set(0.7);
        this._eggContainer._singleEgg.alpha = 0;
        this._eggContainer.addChild(this._eggContainer._singleEgg);
    }

    onDragStart(event) {
        if(!this.interactive) return;
        super.onDragStart(event);
        this._eggContainer._singleEgg.alpha = 1;
        //spawn new egg
    }

    onDragEnd() {
        super.onDragEnd();
        //this.signals.dragEnd.dispatch(this._eggContainer._singleEgg);
        //switch single egg texture to broken egg
    }

    onDragMove() {
        if (this.dragging) {
            let newPos = this.data.getLocalPosition(this);
            this._eggContainer._singleEgg.x = newPos.x;
            this._eggContainer._singleEgg.y = newPos.y < 508 ? newPos.y : 507;
        }
    }

    simpleFloat(){
        this._floatup = new P3.utils.TWEEN.Tween(this._eggContainer)
            .to({
                y: "+10"
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        this._floatdown = new P3.utils.TWEEN.Tween(this._eggContainer)
            .to({
                y: "-10"
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        this._floatup.chain(this._floatdown);
        this._floatdown.chain(this._floatup);
        this._floatup.start();
    }

    playAnimation(isComplete) {
        let rotate = new P3.utils.TWEEN.Tween(this._eggContainer._singleEgg)
            .to({
                rotation: common.deg2rad(50)
            }, 600)
            .onStart(()=>{
                this.interactive = false;
                this._eggContainer._singleEgg.texture = P3.assets.texture('ing_eggs_used');
                this._emitter.visible = true;
                this._emitter.position.set(this._eggContainer._singleEgg.x, this._eggContainer._singleEgg.y)

                let config = this._emitter._config;
                config.emitterLifetime = this.determineEmitterLifetime();
                config.lifetime = {
                    "min": config.emitterLifetime,
                    "max": config.emitterLifetime
                };
                this._emitter.overrideDefaultConfig(config);

                this._emitter._emitter.playOnceAndDestroy(() => {
                    if (isComplete) {
                        this._completed = true;
                        //this._eggContainer._singleEgg.texture = this._emptyTexture;
                        this.floatBackAnimation();
                        this.signals.remove.dispatch(this.id);

                    } else {
                        this.floatBackAnimation();
                        this.createEmitter(this._particleData, this._particleTextures);
                        //this._eggContainer._singleEgg.texture = this._fullTexture;
                    }
                });
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    floatBackAnimation(){
        this.interactive = false;

        if(!this._completed){
            new P3.utils.TWEEN.Tween(this._eggContainer._singleEgg)
                .to({
                    alpha: 0
                }, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onStart(()=>{
                    this.interactive = true;
                })
                .start();
        }else{
            new P3.utils.TWEEN.Tween(this)
                .to({
                    x: 0, y: 0,
                }, 1000)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();
        }


        new P3.utils.TWEEN.Tween(this._eggContainer._singleEgg)
            .to({
                alpha:0
            }, 200)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    rotateWithoutParticle(){
        let shake_1 = new P3.utils.TWEEN.Tween(this._eggContainer._singleEgg)
            .to({
                alpha: 0
            }, 200)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(()=>{
                this.interactive = false;
            })
            .onComplete(()=>{
                this.floatBackAnimation();
                this._eggContainer._singleEgg.position.set(0,0);
            });
        shake_1.start();
    }

    determineEmitterLifetime(){
        if(this._eggContainer._singleEgg.y < 210){
            if(this._eggContainer._singleEgg.y < 150){
                return 1.5;
            }else {
                return 1.2;
            }
        }else{
            if(this._eggContainer._singleEgg.y < 400){
                if(this._eggContainer._singleEgg.y < 300){
                    return 1;
                }else{
                    return 0.75;
                }
            }else{
                return 0.6;
            }
        }
    }
}